import { Injectable } from '@angular/core';
import { WebhooksService as ApiWebhooksService } from '@ducat-pro-wallets/swag-wallet';

import { createApi } from '../utils';

@Injectable({
    providedIn: 'root',
})
export class WebhooksService extends createApi(ApiWebhooksService) {}
